module.exports = __webpack_public_path__ + "static/media/header_bg_mobile.5896ac06.png";